import { inject, Injectable } from '@angular/core';
import { CoreActions } from '@next/core-lib';
import { NotificationActions } from '@next/core-lib/notification';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import { catchError, concatMap, first, map } from 'rxjs/operators';

import * as AppActions from './actions';
import { AppState } from '../shared/models';
import { ApiService } from '../shared/services/api.service';

@Injectable()
export class AppEffects {
  protected readonly store = inject(Store<AppState>);
  protected readonly actions$ = inject(Actions);
  protected readonly api = inject(ApiService);

  loadDataAfterBrowserInitialized$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CoreActions.browserInitialized),
      first(),
      concatMap(() =>
        this.api.getNutrientCategories().pipe(
          map((nutrientCategories) =>
            AppActions.loadNutrientCategoriesSuccess({ nutrientCategories }),
          ),
          catchError(() =>
            of(
              AppActions.loadNutrientCategoriesSuccess({ nutrientCategories: [] }),
              NotificationActions.errorSnackbar({
                message: 'labresults.load-nutrient-categories-error',
              }),
            ),
          ),
        ),
      ),
    ),
  );
}
